module.exports = __webpack_public_path__ + "static/media/icon-remarks.f532bbed.svg";